// extracted by mini-css-extract-plugin
export default {"ChooseQuantityCardsContainer":"ChooseQuantityCardsContainer_ChooseQuantityCardsContainer__e5qOT"};